import { validators } from '../../utils/validators';

const validate = values => {
    const { REQUIRE } = validators;
    const errors = {};
    if (
        !REQUIRE(values.creditCard) &&
        REQUIRE(values.creditCardBusinessSource)
    ) {
        errors.creditCardBusinessSource =
            'Please select at least one Business Source';
    }
    if (!REQUIRE(values.debitCard) && REQUIRE(values.debitCardBusinessSource)) {
        errors.debitCardBusinessSource =
            'Please select at least one Business Source';
    }
    if (!REQUIRE(values.upi) && REQUIRE(values.upiBusinessSource)) {
        errors.upiBusinessSource = 'Please select at least one Business Source';
    }
    if (REQUIRE(values.vpa)) {
        errors.vpa = 'UPI VPA is required when UPI is selected';
    } else if(values?.preVpa?.toLowerCase() !== values?.vpa?.toLowerCase()){
        if (values?.integrationType === 'Online') {
            if (!values.vpa.toLowerCase().startsWith('fcpg')) {
                errors.vpa = 'Online VPA must start with "fcpg"';
            }
        } else if (values?.integrationType === 'Offline') {
            if (!values.vpa.toLowerCase().startsWith('fcbiz')) {
                errors.vpa = 'Offline VPA must start with "fcbiz"';
            }
        }
    }

    if (values.upi && values.upi.includes("SDK") && !values.appId) {
        errors.appId = 'App ID is required when UPI SDK is selected';
    }
    if (!REQUIRE(values.emi) && REQUIRE(values.emiBusinessSource)) {
        errors.emiBusinessSource = 'Please select at least one Business Source';
    }
    return errors;
};

export default validate;
